import React from 'react';
import styled from 'styled-components';
import EveryInput from './EveryInput';
import { translations } from 'gipsy-misc';

var DailyInput = function DailyInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange;

  return React.createElement(
    'div',
    null,
    React.createElement(EveryInput, {
      value: value.every,
      onChange: function onChange(every) {
        return _onChange({ every: every });
      },
      label: translations.taskPanel.recurrency.day
    })
  );
};

export default DailyInput;
//# sourceMappingURL=DailyInput.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/components/DailyInput.js
// module id = 1100
// module chunks = 0